import { Controller } from 'stimulus'
import Choices from 'choices.js'

export default class extends Controller {
  connect() {
    const element = document.querySelector('.js-choice')
    const that = this
    element.addEventListener('blur', this.updateSuggestions)
    if (!this.choices) {
      this.choices = new Choices(element, {
        searchResultLimit: 1000,
        shouldSort: false
      })
      this.choices.passedElement.element.addEventListener(
        'search',
        function(event) {
          that.updateSuggestions(event.detail.value)
        },
        false
      )
    }
    this.element[this.identifier] = this
  }

  updateSuggestions(query) {
    Rails.ajax({
      type: 'get',
      url: '/attendees/search_users',
      data: `query_string=${query}`,
      success: (data) => this.updateChoices(data)
    })
  }

  updateChoices(data) {
    this.choices.setChoices(
      data,
      'id',
      'email',
      true
    )
  }
}
